export default __webpack_public_path__ + "static/media/deforestacion.jpg.3a1f5104.jpg";